export enum TableSortingEnum {
  ApiSorting = 'api-sorting',
  StaticSorting = 'static-sorting',
  NoSorting = 'no-sorting'
}
